import { render, staticRenderFns } from "./PostsKindTabs.vue?vue&type=template&id=2af49ff1&scoped=true"
import script from "./PostsKindTabs.vue?vue&type=script&lang=js"
export * from "./PostsKindTabs.vue?vue&type=script&lang=js"
import style0 from "./PostsKindTabs.vue?vue&type=style&index=0&id=2af49ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af49ff1",
  null
  
)

export default component.exports